import { render, staticRenderFns } from "./EditReserveInbound.vue?vue&type=template&id=f4c75dde&scoped=true&"
import script from "./EditReserveInbound.vue?vue&type=script&lang=js&"
export * from "./EditReserveInbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c75dde",
  null
  
)

export default component.exports